const sendTracking = function (event, data, type) {
  if (window?.cc?.tracking?.updateDatalayer) {
    window.cc.tracking.updateDatalayer(event, data, type)
    return true
  }

  // eslint-disable-next-line
  console.log(
    '[BW] - cannot locate tracking function `window.cc.tracking.updateDatalayer`',
    event,
    data,
    type
  )
  return false
}

const workflowEvent = (
  name,
  step,
  conversion,
  source = '',
  variant = 'default'
) => {
  const data = {
    event: 'workflowevent',
    name,
    step,
    conversion,
    source,
    variant,
  }

  // console.log(data)

  sendTracking('workflow', data, data.event)
}

const formEvent = (name, step, conversion, source = 0, variant = 'default') => {
  const data = {
    event: 'formevent',
    name,
    step,
    conversion,
    source,
    variant,
  }

  // console.log(data)

  sendTracking('form', data, data.event)
}

const ctaEvent = (componentName, componentGroup, action, label) => {
  const data = {
    name: 'ctaevent',
    componentName,
    componentGroup,
    action,
    label,
  }

  // console.log(data)

  sendTracking('event', data, data.name)
}

const componentEvent = (componentName, componentGroup, action, label) => {
  const data = {
    name: 'componentevent',
    componentName,
    componentGroup,
    action,
    label,
  }

  // console.log(data)

  sendTracking('event', data, data.name)
}

export { workflowEvent, formEvent, ctaEvent, componentEvent }
